import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/gattomioNero.png'
import Accordion from '../PrivacePage/Accordion';

const PrivacePage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <PageTitle pageTitle={'Termini'} pagesub={'Termini'} />
            <section className="pf-terms-section section-padding ">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="pf-terms-wrap">
                                <div className="pf-terms-text">
                                    <h2>Condizioni Generali di Vendita</h2>

                                    <p><strong>Venditore:</strong> DTM di Turchiarelli Danilo Francesco — P.IVA 04456570714<br />
                                    Via Contrada Posta Cisterna, Snc — Castelluccio dei Sauri (FG) 71025<br />
                                    Email: dtmacchine@gmail.com — Tel. +39 348 722 6077</p>

                                    <p>Le presenti condizioni regolano l'acquisto di tutti i prodotti disponibili sul sito Gattomio.it. Effettuando un ordine accetti integralmente i termini qui riportati, che costituiscono il contratto tra il venditore e l'acquirente.</p>

                                    <h3>1. Oggetto del Contratto</h3>
                                    <p>I prodotti venduti su Gattomio.it sono selezionati per il benessere e la cura dei gatti. Tra questi, il prodotto principale è la lettiera automatica Kleeo (Modello MSP-08), conforme agli standard CE e ROHS. Le specifiche tecniche di ciascun prodotto sono indicate nella relativa scheda. Ci riserviamo il diritto di annullare ordini in caso di errori palesi nel prezzo pubblicato o esaurimento delle scorte.</p>

                                    <h3>2. Prezzi e Pagamento</h3>
                                    <p>Tutti i prezzi sono espressi in Euro e comprensivi di IVA. Il pagamento avviene tramite i metodi indicati al momento del checkout, gestiti da gateway sicuri e certificati. L'ordine è confermato solo dopo la verifica del pagamento.</p>

                                    <h3>3. Spedizione e Consegna</h3>
                                    <p>Le spedizioni avvengono sul territorio italiano. I tempi di consegna indicati sono stimati e possono variare in base al corriere e alla destinazione. In caso di mancata consegna per assenza del destinatario, il pacco verrà messo in giacenza secondo le procedure del corriere.</p>

                                    <h3>4. Garanzia Legale</h3>
                                    <p>Tutti i prodotti sono coperti dalla garanzia legale di conformità di 24 mesi prevista dal Codice del Consumo (D.Lgs. 206/2005). Non sono coperti i danni derivanti da uso improprio, manomissione o normale usura.</p>

                                    <h3>5. Diritto di Recesso</h3>
                                    <p>Hai diritto di recedere dall'acquisto entro 14 giorni dalla ricezione del prodotto, senza dover fornire alcuna motivazione. Per esercitare il recesso contatta dtmacchine@gmail.com. Il prodotto deve essere restituito integro e nelle condizioni originali. Le spese di reso sono a carico del cliente, salvo prodotti difettosi o non conformi.</p>

                                    <h3>6. Responsabilità</h3>
                                    <p>Il venditore non è responsabile per un utilizzo improprio dei prodotti acquistati. Si raccomanda di leggere attentamente le istruzioni allegate a ciascun prodotto prima dell'uso.</p>
                                </div>
                                <div className="pf-faq-section" style={{marginTop: '50px'}}>
                                    <h4>Domande Frequenti</h4>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-12">
                                            <Accordion />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default PrivacePage;